import React from 'react';

interface HowItWorksProps {
  onStartApplication?: () => void;
}

const HowItWorks: React.FC<HowItWorksProps> = ({ onStartApplication }) => {
  const steps = [
    {
      step: '01',
      title: 'Apply Online',
      description: 'Fill out our simple 5-minute application form with your basic information and income details.',
      icon: '📝'
    },
    {
      step: '02',
      title: 'Get Pre-Approved',
      description: 'Receive your pre-approval decision instantly with your personalized loan terms and budget.',
      icon: '✅'
    },
    {
      step: '03',
      title: 'Choose Your Car',
      description: 'Browse our extensive inventory of quality vehicles that fit your budget and preferences.',
      icon: '🚗'
    },
    {
      step: '04',
      title: 'Drive Away',
      description: 'Complete the final paperwork and drive away in your new car the same day.',
      icon: '🎉'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Getting your dream car is easier than ever. Follow these simple steps to get started today.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-blue-200 transform translate-x-4 z-0"></div>
              )}
              
              <div className="relative z-10 bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="text-center">
                  <div className="text-6xl mb-4">{step.icon}</div>
                  <div className="text-2xl font-bold text-blue-600 mb-2">{step.step}</div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <button 
            onClick={onStartApplication}
            className="bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-colors shadow-lg"
          >
            Start Your Application
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
